import React from "react"
import { Card as PrimeCard } from "primereact/card"

const forwardRef =
  /** @type {typeof React.forwardRef<PrimeCard, import("primereact/card").CardProps>} */ (
    React.forwardRef
  )

const Card = forwardRef((props, ref) => {
  return <PrimeCard {...props} ref={ref} />
})

export default Card
